"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Item = _interopRequireDefault(require("./Item"));
var _paulCorePackage = require("paul-core-package");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const List = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    idList = []
  } = _ref;
  const PoeModelHeight = 20;
  return idList.map((equipmentId, i) => /*#__PURE__*/_react.default.createElement(_Item.default, {
    key: equipmentId,
    equipmentId: equipmentId,
    position: [PoeModelHeight * i, 0, 0]
  }));
}, function () {
  let prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _paulCorePackage.functions.areEqual(prev.idList, next.idList);
});
List.propTypes = {
  idList: _propTypes.default.arrayOf(_propTypes.default.string)
};
var _default = exports.default = List;